<template>
    <div>
        <filter-main-layout
                filter-key="filter-main-tyre-moto"
                :select-fields="getSelectAndSlugSelectFields"
                :disabledValues="getDisabledValues"
                :checkboxes-fields="getCheckboxFields"
                :loading="loading"
                @change="filterValues"
                @submit="searchProducts"
                :reset-link="'/catalog/moto/tyre/all/all/all/all/all'"
        >
        </filter-main-layout>
    </div>
</template>

<script>
    import FilterMainLayout from './FilterMainLayout';
    import {mapActions, mapState, mapGetters} from "vuex";

    export default {
        name: "TheFilterMainTyreMoto",
        components: {FilterMainLayout},
        computed: {
          ...mapState('topParamMotoTyreModule', {
            paramInfo: 'paramInfo',
            loading: 'loading'
          }),
          ...mapGetters('topParamMotoTyreModule', {
            getSelectFields: 'getSelectFields',
            getSelectAndSlugSelectFields: 'getSelectAndSlugSelectFields',
            getCheckboxFields: 'getCheckboxFields',
            isCurrentPossible: 'isCurrentPossible',
            getDisabledValues: 'getDisabledValues',
          })
        },
        methods: {
          ...mapActions('topParamMotoTyreModule', {
            filterValues: 'filterValues',
            initializationFilter: 'initializationFilter',
            searchProducts: 'searchProducts'
          }),
        },
        mounted() {
          this.initializationFilter();
        }
    }
</script>

<style lang="scss">

</style>